<template>
  <v-container fluid class="home-container">
    <!-- Filtros -->
    <div class="av-card av-filtro-card">
      <span class="av-section-label">Filtros</span>
      <v-row dense align="end">
        <v-col cols="12" sm="6" md="4" v-if="user.tipo == 'ADMIN'">
          <label class="av-field-label">Empresa</label>
          <v-autocomplete
            outlined
            dense
            hide-details
            v-model="empresaSelecionada"
            :items="empresas"
            item-text="nome"
            item-value="id"
            placeholder="Selecione a empresa"
            no-data-text="Nenhuma empresa encontrada"
            @change="onEmpresaChange"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <label class="av-field-label">Pesquisa(s)</label>
          <v-select
            ref="selectPesquisas"
            class="select-unidade-fixo"
            outlined
            dense
            v-model="pesquisaId"
            :items="pesquisas"
            item-text="titulo"
            item-value="id"
            placeholder="Selecione a(s) pesquisa(s)"
            hide-details
            multiple
            :menu-props="{ maxHeight: '400' }"
            @change="onPesquisaChange"
          >
            <template v-slot:item="data">
              <v-list-item v-bind="data.attrs" v-on="data.on">
                <v-list-item-action>
                  <v-checkbox
                    v-if="data.item.id === 'Todos'"
                    :input-value="todosSelecionados"
                    :ripple="false"
                    @click.stop="onTodosClick"
                  ></v-checkbox>
                  <v-checkbox
                    v-else
                    :input-value="pesquisaId.includes(data.item.id)"
                    :ripple="false"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.titulo }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="data">
              <span v-if="data.index === 0">
                <span v-if="pesquisaId.length > 1">{{ pesquisaId.length }} pesquisas selecionadas</span>
                <span v-else-if="pesquisaId.length === 1">{{ data.item.titulo }}</span>
              </span>
            </template>
          </v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <label class="av-field-label">Pergunta</label>
          <v-select
            outlined
            dense
            v-model="perguntaId"
            :items="perguntas"
            item-text="titulo"
            item-value="id"
            placeholder="Selecione a pergunta"
            @input="exibePergunta()"
            no-data-text="Nenhuma pergunta para escolher"
            hide-details
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <label class="av-field-label">Data Início</label>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                light
                v-model="dateFormattedInicio"
                append-icon="mdi-calendar"
                @blur="date = parseDate(dateFormattedInicio)"
                v-on="on"
                outlined
                dense
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataInicio" no-title @input="menu1 = false" locale="pt-br"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <label class="av-field-label">Data Fim</label>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                light
                v-model="dateFormattedFim"
                append-icon="mdi-calendar"
                @blur="date = parseDate(dateFormattedFim)"
                v-on="on"
                outlined
                dense
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="dataFim" no-title @input="menu2 = false" locale="pt-br"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-btn block depressed color="primary" :disabled="pesquisaId.length === 0" @click="exibePergunta">
            <v-icon left>mdi-magnify</v-icon>Buscar
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <!-- Cards de Métricas -->
    <v-row class="mt-1">
      <v-col cols="12" sm="6" md="3">
        <div
          class="av-card av-metric av-metric--clickable"
          style="--accent: #E53935"
          @click="tabelaDetratores.conteudoDetratores.length >= 1 ? exibeDetratores() : ''"
        >
          <div class="av-metric-head">
            <div class="av-metric-info">
              <span class="av-metric-title">Detratores</span>
              <span class="av-metric-sub">Notas de 0 a 6</span>
            </div>
            <v-progress-circular :rotate="-90" :size="54" :width="6" :value="percentDetra" color="#E53935">
              <span class="av-metric-pct">{{ percentDetra.toFixed(0) }}%</span>
            </v-progress-circular>
          </div>
          <div class="av-metric-value">{{ detratores }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <div class="av-card av-metric" style="--accent: #FFA000">
          <div class="av-metric-head">
            <div class="av-metric-info">
              <span class="av-metric-title">Neutros</span>
              <span class="av-metric-sub">Notas de 7 a 8</span>
            </div>
            <v-progress-circular :rotate="-90" :size="54" :width="6" :value="percenteNeutro" color="#FFA000">
              <span class="av-metric-pct">{{ percenteNeutro.toFixed(0) }}%</span>
            </v-progress-circular>
          </div>
          <div class="av-metric-value">{{ neutros }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <div class="av-card av-metric" style="--accent: #43A047">
          <div class="av-metric-head">
            <div class="av-metric-info">
              <span class="av-metric-title">Promotores</span>
              <span class="av-metric-sub">Notas de 9 a 10</span>
            </div>
            <v-progress-circular :rotate="-90" :size="54" :width="6" :value="percentPromo" color="#43A047">
              <span class="av-metric-pct">{{ percentPromo.toFixed(0) }}%</span>
            </v-progress-circular>
          </div>
          <div class="av-metric-value">{{ promotores }}</div>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <div class="av-card av-metric" :style="{ '--accent': corPontNps || '#9e9e9e' }">
          <div class="av-metric-head">
            <div class="av-metric-info">
              <span class="av-metric-title">Pontuação NPS</span>
              <span class="av-metric-sub">Cálculo total</span>
            </div>
            <v-icon size="38" :color="corPontNps || 'grey'">{{ iconMsg }}</v-icon>
          </div>
          <div class="av-metric-value">{{ pontuacao.toFixed(0) }}</div>
        </div>
      </v-col>
    </v-row>

    <!-- Mensagem de Status -->
    <v-row>
      <v-col cols="12">
        <v-alert :icon="iconMsg" prominent text :color="corMsg" class="mt-4 mb-6" elevation="2">
          <span class="font-weight-bold">{{msgPontuacao}}</span> {{descPontuacao}}
        </v-alert>
      </v-col>
    </v-row>

    <!-- Gráficos -->
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="chart-card" elevation="2" style="height: 500px; min-height: 450px; display: flex; flex-direction: column;">
          <v-card-title class="text-h6 font-weight-medium d-flex align-center">
            Pesquisas realizadas
            <v-spacer></v-spacer>
            <v-select
              v-model="tipoGraficoPesquisas"
              :items="['Geral', 'Por unidade']"
              dense
              outlined
              hide-details
              style="max-width: 150px;"
            ></v-select>
          </v-card-title>
          <v-card-text style="flex: 1 1 auto; display: flex; flex-direction: column; justify-content: stretch;">
            <apexchart
              :key="chartSeries[0].data.length + '-' + chartOptions.xaxis.categories.join(',')"
              type="bar"
              height="100%"
              :options="chartOptions"
              :series="chartSeries"
            ></apexchart>
          </v-card-text>
          <div v-if="tipoGraficoPesquisas === 'Por unidade'" class="legenda-unidades" style="margin-top: 8px; text-align: center;">
            <span v-for="(nome, idx) in legendaUnidades" :key="idx" style="display: inline-block; min-width: 80px; margin: 0 8px; font-size: 13px;">
              <b>{{ idx + 1 }}</b>: {{ nome }}
            </span>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="chart-card" elevation="2" style="height: 500px; min-height: 450px; display: flex; flex-direction: column;">
          <v-card-title class="text-h6 font-weight-medium d-flex align-center">
            Evolução do NPS
            <v-spacer></v-spacer>
            <v-select
              v-model="tipoEvolucaoNPS"
              :items="['Geral', 'Por unidade']"
              dense
              outlined
              hide-details
              style="max-width: 150px; margin-right: 8px;"
            ></v-select>
            <v-chip
              :color="evolucaoNPSStatus.color"
              small
              class="ml-2"
            >
              <v-icon left small>{{evolucaoNPSStatus.icon}}</v-icon>
              {{evolucaoNPSStatus.text}}
            </v-chip>
          </v-card-title>
          <v-card-text style="flex: 1 1 auto; display: flex; flex-direction: column; justify-content: stretch;">
            <apexchart
              type="line"
              height="100%"
              :options="lineChartOptions"
              :series="lineChartSeries"
            ></apexchart>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="chart-card" elevation="2">
          <v-card-title class="text-h6 font-weight-medium">
            Distribuição de Notas
          </v-card-title>
          <v-card-text>
            <apexchart
              type="heatmap"
              height="300"
              :options="heatmapOptions"
              :series="heatmapSeries"
            ></apexchart>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="chart-card" elevation="2">
          <v-card-title class="text-h6 font-weight-medium">
            Comparativo Mensal
            <v-spacer></v-spacer>
            <v-select
              v-model="mesComparativo"
              :items="mesesDisponiveis"
              dense
              outlined
              hide-details
              class="month-select"
            ></v-select>
          </v-card-title>
          <v-card-text>
            <apexchart
              type="radar"
              height="300"
              :options="radarChartOptions"
              :series="radarChartSeries"
            ></apexchart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Diálogos -->
    <v-dialog v-model="dialogoExibeDetratores" persistent max-width="950px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">Detratores</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <div class="av-toolbar">
            <v-text-field
              v-model="tabelaDetratores.busca"
              append-icon="mdi-magnify"
              label="Procurar"
              outlined
              dense
              hide-details
              single-line
              class="av-busca"
            ></v-text-field>
          </div>
          <v-data-table
            :search="tabelaDetratores.busca"
            :headers="tabelaDetratores.cabecalho"
            :items="tabelaDetratores.conteudoDetratores"
            class="av-table"
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.created`]="{ item }">
              <span>{{ transformaData(item.created, 'DD/MM/YYYY') }} às {{ transformaData(item.created, 'HH:mm:ss') }}</span>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon small v-on="on" @click="verDetalhes(item)">
                    <v-icon small color="primary">mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalhes</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-alert dense text outlined type="warning" class="my-4">
                Nenhuma avaliação encontrada
              </v-alert>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary">
            <download-csv :data="listaDetratores" encoding="UTF-8" name="Relatorio de Detratores.csv" :separator-excel="true">
              <span class="av-export-label"><v-icon left small>mdi-cloud-download</v-icon>Baixar relatório</span>
            </download-csv>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="dialogoExibeDetratores = false" text>Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogoExibeDetalhesDetratores" persistent max-width="1200px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">Detalhes</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <v-data-table
            :headers="tabelaDetratoresDetalhes.cabecalho"
            :items="tabelaDetratoresDetalhes.conteudo"
            class="av-table"
            :footer-props="{
              'items-per-page-text': 'Linhas por página',
              'items-per-page-all-text': 'Tudo',
            }"
          >
            <template v-slot:[`item.envioMensagem`]="{ item }">
              <span v-if="item.envioMensagem">{{ transformaData(item.envioMensagem, 'DD/MM/YYYY') }} às {{ transformaData(item.envioMensagem, 'HH:mm:ss') }}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:no-data>
              <v-alert dense text outlined type="warning" class="my-4">
                Nenhuma avaliação encontrada
              </v-alert>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogoExibeDetalhesDetratores = false" text>Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="false" color="#60b5b1" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import axios from 'axios'
  import PH from 'print-html-element'
  import { mapState } from 'vuex'
  import Snackbar from '../componentes/snackbar.vue'
  import moment from 'moment'
  import VueApexCharts from 'vue-apexcharts'

  export default {
    components: {Snackbar, Loading, apexchart: VueApexCharts},
    data: vm => ({
      tabelaDetratores: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'clienteNome', },
          { text: 'Telefone', align: 'start', value: 'clienteTelefone', },
          { text: 'Nota', align: 'start', value: 'nota', },
          { text: 'Questionário', align: 'start', value: 'questionario', },
          { text: 'Enviado em', align: 'start', value: 'envioMensagem', },
          { text: 'Detalhes', align: 'start', value: 'actions', },
        ],
        conteudo: [],
      },
      tabelaDetratoresDetalhes: {
        cabecalho: [],
        conteudo: [],
      },
      dialogoExibeDetalhesDetratores: false,
      diasSelc: 7,
      corSelec: '#388E3C',
      fab: false,
      fullPage: true,
      isLoading: false,
      empresas: [],
      empresaSelecionada: '',
      pesquisaId: [],
      perguntaId: '',
      perguntaSelecionada: '',
      pesquisas: [],
      perguntas: [],
      respostas: [],
      totalRespostadia: [],
      detraDia: 0,
      neutroDia: 0,
      promoDia: 0,
      datasGrap:[],
      detratores: 0,
      neutros: 0,
      promotores: 0,
      percentDetra: 0,
      percenteNeutro: 0,
      percentPromo: 0,
      pontuacao: 0,
      promotorGrap: 0,
      detratorGrap: 0,
      neutroGrap: 0,
      corPontNps:'',
      msgPontuacao: '',
      descPontuacao: '',
      corMsg: '',
      iconMsg: 'sentiment_very_dissatisfied',
      datePeriodo:'',
      tab: null,
      names: [ "Detratores", "Neutros", "Promotores" ],
      namesLine: [ "Pontuação NPS" ],
      colorLine: ["#424f4e"],
      colors: ["#E53935","#FFA000","#43A047"],
      values: [
        [''],
        [''],
        ['']
      ],
      pontuacaoDia: [
        ['']
      ],
      pontuacaoTotal: [
        [],
        [],
        []
      ],
      dialogoExibeDetratores: false,
      date: new Date().toISOString().substring(0, 10),
      menu1: false,
      menu2: false,
      dateFormattedInicio: vm.formatData(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dateFormattedFim: vm.formatData(new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10)),
      dataInicio: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      dataFim: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      listaDetratores: [],
      mesComparativo: 'Atual',
      mesesDisponiveis: ['Atual', 'Último Mês', 'Há 2 Meses'],
      tipoEvolucaoNPS: 'Geral',
      tipoGraficoPesquisas: 'Geral',
      legendaUnidades: [],
      debounceTimeout: null,

      // Configurações do gráfico de barras
      chartOptions: {
        chart: {
          stacked: true,
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            borderRadius: 5,
          },
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: [],
        },
        colors: ['#E53935', '#FFA000', '#43A047'],
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        },
        fill: {
          opacity: 1
        },
        tooltip: { y: {} }
      },
      chartSeries: [
        {
          name: 'Detratores',
          data: []
        },
        {
          name: 'Neutros',
          data: []
        },
        {
          name: 'Promotores',
          data: []
        }
      ],

      // Configurações do gráfico de linha
      lineChartOptions: {
        chart: {
          type: 'line',
          toolbar: {
            show: false
          }
        },
        legend: {
          position: 'bottom',
          fontSize: '13px',
          itemMargin: { horizontal: 10, vertical: 4 },
          markers: { width: 12, height: 12, radius: 12 },
          onItemClick: { toggleDataSeries: true },
          onItemHover: { highlightDataSeries: true },
          floating: false
        },
        stroke: {
          curve: 'smooth',
          width: 3
        },
        markers: {
          size: 4
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          min: -100,
          max: 100
        },
        colors: [],
        grid: {
          borderColor: '#f1f1f1'
        }
      },
      lineChartSeries: [{
        name: 'NPS',
        data: []
      }],

      // Configurações do heatmap
      heatmapOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          heatmap: {
            colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 2,
                  color: '#E53935',
                  name: 'Baixo'
                },
                {
                  from: 3,
                  to: 6,
                  color: '#FFA000',
                  name: 'Médio'
                },
                {
                  from: 7,
                  to: 10,
                  color: '#43A047',
                  name: 'Alto'
                }
              ]
            }
          }
        },
        dataLabels: {
          enabled: true
        },
        xaxis: {
          type: 'category',
          categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
        }
      },
      heatmapSeries: [
        {
          name: 'Frequência',
          data: []
        }
      ],

      // Configurações do gráfico radar
      radarChartOptions: {
        chart: {
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: ['NPS', 'Detratores', 'Neutros', 'Promotores', 'Respostas']
        },
        fill: {
          opacity: 0.5
        }
      },
      radarChartSeries: [
        {
          name: 'Mês Atual',
          data: []
        },
        {
          name: 'Mês Anterior',
          data: []
        }
      ]
    }),

    computed: {
      ...mapState({
        usuarioadmin: state => state.Userpermission,
        usuarioLogado: state => state.isMenuVisible,
        user: state => state.userObj,
        companyobj: state => state.companyObj
      }),
      empresaAtivaId() {
        return this.user.tipo === 'ADMIN' ? this.empresaSelecionada : this.companyobj.id
      },
      computedDateFormattedInicio () {
        return this.formatData(this.dataInicio)
      },
      computedDateFormattedFim () {
        return this.formatData(this.dataFim)
      },
      evolucaoNPSStatus() {
        // Calcula a variação do NPS em relação ao período anterior
        const ultimoNPS = this.lineChartSeries[0].data[this.lineChartSeries[0].data.length - 1]
        const penultimoNPS = this.lineChartSeries[0].data[this.lineChartSeries[0].data.length - 2]

        if (!ultimoNPS || !penultimoNPS) return { color: 'grey', icon: 'mdi-minus', text: 'Sem dados' }

        const variacao = ultimoNPS - penultimoNPS

        if (variacao > 0) {
          return { color: 'success', icon: 'mdi-trending-up', text: `+${variacao}%` }
        } else if (variacao < 0) {
          return { color: 'error', icon: 'mdi-trending-down', text: `${variacao}%` }
        }
        return { color: 'warning', icon: 'mdi-trending-neutral', text: 'Estável' }
      },
      todosSelecionados() {
        // Desconta o item 'Todos' da contagem
        return this.pesquisaId.length === this.pesquisas.filter(p => p.id !== 'Todos').length;
      }
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaDados()
      }
    },

    watch: {
      dialog(val) {
        val || this.close()
      },
      dataInicio() {
        this.dateFormattedInicio = this.formatData(this.dataInicio)
      },
      dataFim() {
        this.dateFormattedFim = this.formatData(this.dataFim)
      },
      dialogoExibeDetalhesDetratores() {
        if (!this.dialogoExibeDetalhesDetratores) {
          this.dialogoExibeDetratores = true
          this.tabelaDetratoresDetalhes.cabecalho = []
          this.tabelaDetratoresDetalhes.conteudo = []
        }
      },
      mesComparativo() {
        this.atualizarRadar()
      },
      tipoEvolucaoNPS() {
        this.calculaNPS()
      },
      tipoGraficoPesquisas() {
        this.calculaNPS()
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data && response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      onEmpresaChange() {
        // Ao trocar a empresa, reinicia as seleções e recarrega os questionários
        this.pesquisaId = []
        this.perguntaId = ''
        this.perguntas = []
        this.pesquisas = []
        this.carregaDados()
      },

      async carregaDados() {
        if (!this.empresaAtivaId) return
        this.isLoading = true
        await axios.get(`${baseApiUrl}Questionarios?filter[where][empresaId]=${this.empresaAtivaId}&access_token=${sessionStorage.getItem('accToken')}`)
        .then(res => {
          this.pesquisas = res.data || []

          if (this.companyobj.nome && this.companyobj.nome.toLowerCase().includes('roseanne')) {
            this.pesquisas.push({
              'titulo': 'Todos',
              'id': 'Todos'
            })
          }

          // Inicializa pesquisaId apenas se o usuário não selecionou nada
          if (this.pesquisas.length > 0 && (!this.pesquisaId || this.pesquisaId.length === 0)) {
            this.pesquisaId = [this.pesquisas[0].id];
          }
        })

        // Empresa sem questionários: limpa o painel e encerra o carregamento
        if (!this.pesquisas || this.pesquisas.length === 0) {
          this.perguntas = []
          this.perguntaId = ''
          this.isLoading = false
          return
        }

        this.carregaPerguntas()
      },

      carregaPerguntas() {
        // Sempre limpa perguntas e perguntaId ao trocar unidade
        this.perguntaId = '';
        this.perguntas = [];
        if (this.pesquisaId.length === 0) {
          this.pesquisaId = []
        }
        if (this.pesquisaId.length === this.pesquisas.length - 1) {
          this.carregaTodasRespostas(this.dataInicio, this.dataFim)
        } else if (this.pesquisaId.length === 1) {
          axios.get(
            baseApiUrl + 'Perguntas?filter=' +
            encodeURIComponent(JSON.stringify({
              where: {
                and: [
                  { questionarioId: { inq: [this.pesquisaId[0]] } },
                  { tipo: 'NPS' }
                ]
              }
            })) +
            '&access_token=' + sessionStorage.getItem('accToken')
          )
          .then(res => {
            this.perguntas = res.data
            if (res.data.length > 0) {
              const perguntaCorreta = res.data.find(p => p.questionarioId === this.pesquisaId[0])
              this.perguntaId = perguntaCorreta ? perguntaCorreta.id : res.data[0].id
              this.exibePergunta()
            } else {
              this.isLoading = false
            }
          })
        } else if (this.pesquisaId.length > 1) {
          this.carregaRespostasMultiplas(this.dataInicio, this.dataFim)
        }
      },

      async exibePergunta() {
        this.isLoading = true
        this.respostas = []

        if (this.pesquisaId.includes('Todos')) {
          await this.carregaTodasRespostas(this.dataInicio, this.dataFim)
        } else if (this.pesquisaId.length === 1) {
          // Sempre use o id da unidade selecionada
          await axios.get(`${baseApiUrl}Respostas?filter={"where":{"and":[{"perguntaId":"${this.perguntaId}"},{"created":{"gte":"${this.dataInicio+"T00:00:00.000Z"}"}},{"created":{"lte":"${this.dataFim+"T23:59:59.999Z"}"}}]}, "include":"questionario"}&access_token=${sessionStorage.getItem('accToken')}`)
            .then(res => {
              this.respostas = res.data
              this.pegaDetratores(res.data, null)
            })

          for (var key in this.perguntas) {
            if (this.perguntas.hasOwnProperty(key)) {
              if (this.perguntas[key].id == this.perguntaId)
                this.perguntaSelecionada = this.perguntas[key].titulo
            }
          }
        } else if (this.pesquisaId.length > 1) {
          await this.carregaRespostasMultiplas(this.dataInicio, this.dataFim)
        }
        // Garantir que o gráfico de evolução seja atualizado
        this.calculaNPS()
        this.atualizarGraficos()
        this.isLoading = false
      },

      calculaNPS() {
        this.detratores = 0
        this.neutros = 0
        this.promotores = 0
        this.percentDetra = 0
        this.percenteNeutro = 0
        this.percentPromo = 0
        this.pontuacao = 0
        this.datasGrap = []
        var datas = []
        var dados = []
        this.values = []
        this.detratorGrap = 0
        this.neutroGrap = 0
        this.promotorGrap = 0
        for (var i=0; i<=2; i++) {
          this.values.push([0,0,0])
        }

        var posDet = 0
        var posNeut = 0
        var posPromo = 0
        for (var key in this.respostas) {
          if (this.respostas.hasOwnProperty(key)) {
            datas.push(this.formatDate(this.respostas[key].created))
            dados.push({'data':`${this.formatDate(this.respostas[key].created)}`,'nota':`${this.respostas[key].nota}`})
            switch (this.respostas[key].nota) {
              case 0:
                this.detratores = this.detratores+1
                break;
              case 1:
                this.detratores = this.detratores+1
                break;
              case 2:
                this.detratores = this.detratores+1
                break;
              case 3:
                this.detratores = this.detratores+1
                break;
              case 4:
                this.detratores = this.detratores+1
                break;
              case 5:
                this.detratores = this.detratores+1
                break;
              case 6:
                this.detratores = this.detratores+1
                break;
              case 7:
                this.neutros = this.neutros+1
                break;
              case 8:
                this.neutros = this.neutros+1
                break;
              case 9:
                this.promotores = this.promotores+1
                break;
              case 10:
                this.promotores = this.promotores+1
                break;
              default:
                break;
            }
          }
        }
        this.datasGrap = datas.filter((este, i) => datas.indexOf(este) === i)
        for (var key2 in dados) {
          if (dados.hasOwnProperty(key2)) {
            if (this.datasGrap.filter( a => dados[key2].data.includes( a ) ) && dados[key2].nota >= 0 && dados[key2].nota <= 6) {
              this.values[0].length = this.datasGrap.length
              for (var l=0; l<=this.datasGrap.length; l++) {
                if (this.datasGrap[l] == dados[key2].data && dados[key2].nota >= 0 && dados[key2].nota <= 6) {
                  if (posDet == l)
                    this.detratorGrap++
                  else
                    this.detratorGrap = 1
                  this.values[0][l] = this.detratorGrap
                  posDet =  l
                }
              }
            }
            if (this.datasGrap.filter( a => dados[key2].data.includes( a ) )  && dados[key2].nota >= 7 && dados[key2].nota <= 8) {
              this.values[1].length = this.datasGrap.length
              for (var j=0; j<=this.datasGrap.length; j++) {
                if (this.datasGrap[j] == dados[key2].data && dados[key2].nota >= 7 && dados[key2].nota <= 8) {
                  if (posNeut == j)
                    this.neutroGrap++
                  else
                    this.neutroGrap = 1
                  this.values[1][j] = this.neutroGrap
                  posNeut = j
                }
              }
            }
            if (this.datasGrap.filter( a => dados[key2].data.includes( a ) )  && dados[key2].nota >= 9 && dados[key2].nota <= 10) {
              this.values[2].length = this.datasGrap.length
              for (var k=0; k<=this.datasGrap.length; k++) {
                if (this.datasGrap[k] == dados[key2].data && dados[key2].nota >= 9 && dados[key2].nota <= 10) {
                  if (posPromo == k)
                    this.promotorGrap++
                  else
                    this.promotorGrap = 1
                  this.values[2][k] = this.promotorGrap
                  posPromo = k
                }
              }
            }
          }
        }
        this.calculaNPSTotal()

        // Atualizar dados do gráfico de barras
        if (this.tipoGraficoPesquisas === 'Geral') {
          this.chartSeries = [
            {
              name: 'Detratores',
              data: this.pontuacaoTotal[0]
            },
            {
              name: 'Neutros',
              data: this.pontuacaoTotal[1]
            },
            {
              name: 'Promotores',
              data: this.pontuacaoTotal[2]
            }
          ]
          this.chartOptions.xaxis.categories = this.datasGrap
          this.chartOptions.xaxis.labels = { rotate: 0 }
          this.chartOptions.tooltip = { y: {} }
          // Ajuste para apenas uma barra
          if (this.chartSeries[0].data.length === 1) {
            this.chartOptions.plotOptions.bar.columnWidth = '80%';
            this.chartOptions.xaxis.categories = ['1'];
          } else {
            this.chartOptions.plotOptions.bar.columnWidth = '55%';
          }
        } else {
          // Agrupar por questionarioId
          const respostasPorUnidade = {};
          this.respostas.forEach(r => {
            const id = String(r.questionarioId);
            if (!respostasPorUnidade[id]) {
              respostasPorUnidade[id] = { detratores: 0, neutros: 0, promotores: 0 };
            }
            if (r.nota <= 6) respostasPorUnidade[id].detratores++;
            else if (r.nota <= 8) respostasPorUnidade[id].neutros++;
            else respostasPorUnidade[id].promotores++;
          });
          // Montar arrays puros de ids e títulos
          let unidadeIds = Array.from(Object.keys(respostasPorUnidade));
          // Se não houver respostas, mas uma unidade está selecionada, mostrar ela com valores zero
          if (unidadeIds.length === 0 && this.pesquisaId && this.pesquisaId.length === 1) {
            unidadeIds = [String(this.pesquisaId[0])];
            respostasPorUnidade[String(this.pesquisaId[0])] = { detratores: 0, neutros: 0, promotores: 0 };
          }
          const unidadeTitulos = unidadeIds.map(id => {
            const pesquisa = this.pesquisas.find(p => String(p.id) == id);
            return pesquisa ? pesquisa.titulo : 'Unidade desconhecida';
          });
          const numeros = unidadeIds.map((_, idx) => (idx + 1).toString());
          this.chartSeries = [
            {
              name: 'Detratores',
              data: unidadeIds.map(id => respostasPorUnidade[id].detratores)
            },
            {
              name: 'Neutros',
              data: unidadeIds.map(id => respostasPorUnidade[id].neutros)
            },
            {
              name: 'Promotores',
              data: unidadeIds.map(id => respostasPorUnidade[id].promotores)
            }
          ];
          // Ajuste para apenas uma barra
          if (numeros.length === 1) {
            // Garante que sempre haverá pelo menos um valor para cada série
            this.chartSeries = [
              { name: 'Detratores', data: [respostasPorUnidade[unidadeIds[0]].detratores || 0] },
              { name: 'Neutros', data: [respostasPorUnidade[unidadeIds[0]].neutros || 0] },
              { name: 'Promotores', data: [respostasPorUnidade[unidadeIds[0]].promotores || 0] }
            ];
            this.chartOptions.xaxis.categories = unidadeTitulos.length ? [unidadeTitulos[0]] : ['Unidade'];
            this.chartOptions.plotOptions.bar.columnWidth = '80%';
          } else {
            this.chartSeries = [
              { name: 'Detratores', data: unidadeIds.map(id => respostasPorUnidade[id].detratores) },
              { name: 'Neutros', data: unidadeIds.map(id => respostasPorUnidade[id].neutros) },
              { name: 'Promotores', data: unidadeIds.map(id => respostasPorUnidade[id].promotores) }
            ];
            this.chartOptions.plotOptions.bar.columnWidth = '55%';
            this.chartOptions.xaxis.categories = Array.from(numeros);
          }
          this.chartOptions.xaxis.labels = { rotate: 0 };
          // Salvar os nomes para a legenda personalizada
          this.legendaUnidades = Array.from(unidadeTitulos);
          // Tooltip customizado para mostrar o nome da unidade
          this.chartOptions.tooltip = {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
              const legenda = w.config && w.config.legendaUnidades ? Array.from(w.config.legendaUnidades) : [];
              let unidade = legenda && legenda[dataPointIndex] ? legenda[dataPointIndex] : 'Unidade desconhecida';
              const valor = series[seriesIndex][dataPointIndex];
              const nomeSerie = w.globals.seriesNames[seriesIndex];
              return `<div style='padding:8px;'><b>Unidade:</b> ${unidade}<br/><b>${nomeSerie}:</b> ${valor}</div>`;
            }
          };
          // Passar as legendas para o config do gráfico
          this.chartOptions.legendaUnidades = Array.from(unidadeTitulos);
        }

        // Atualizar dados do gráfico de linha
        if (this.tipoEvolucaoNPS === 'Geral') {
          this.lineChartSeries = [{
            name: 'NPS',
            data: this.pontuacaoDia[0]
          }]
          this.lineChartOptions.colors = ['#424f4e']
        } else {
          // Por unidade: uma linha para cada unidade selecionada
          const series = []
          const cores = [
            '#1565C0', '#E53935', '#43A047', '#FFA000', '#8E24AA', '#00897B', '#F4511E', '#3949AB', '#00ACC1', '#C0CA33',
            '#D81B60', '#00838F', '#C62828', '#AD1457', '#6A1B9A', '#4527A0', '#283593', '#0277BD', '#00695C', '#2E7D32',
            '#FF6F00', '#FF8F00', '#A1887F', '#455A64', '#C0CA33', '#FDD835', '#FFB300', '#FF7043', '#8D6E63', '#789262',
          ]
          // Agrupar respostas por unidade
          const respostasPorUnidade = {}
          this.respostas.forEach(r => {
            const unidade = r.questionario && r.questionario.titulo ? r.questionario.titulo : (r.questionarioId || 'Desconhecido')
            if (!respostasPorUnidade[unidade]) respostasPorUnidade[unidade] = []
            respostasPorUnidade[unidade].push(r)
          })
          Object.keys(respostasPorUnidade).forEach(unidade => {
            // Calcular evolução do NPS para cada unidade
            const respostas = respostasPorUnidade[unidade]
            // Agrupar por data
            const datas = [...new Set(respostas.map(r => this.formatDate(r.created)))]
            datas.sort((a, b) => {
              const [da, ma] = a.split('/');
              const [db, mb] = b.split('/');
              return new Date(2023, ma-1, da) - new Date(2023, mb-1, db)
            })
            const npsPorData = datas.map(data => {
              const respostasData = respostas.filter(r => this.formatDate(r.created) === data)
              let det = 0, pro = 0
              respostasData.forEach(r => {
                if (r.nota <= 6) det++
                else if (r.nota > 8) pro++
              })
              const total = respostasData.length
              const percentDet = total ? (det * 100 / total) : 0
              const percentPro = total ? (pro * 100 / total) : 0
              return parseInt(percentPro.toFixed(0)) - parseInt(percentDet.toFixed(0))
            })
            // Buscar o nome da unidade pelo ID
            const pesquisa = this.pesquisas.find(p => p.id == unidade);
            const nomeUnidade = pesquisa ? pesquisa.titulo : unidade;
            series.push({
              name: nomeUnidade,
              data: npsPorData
            })
          })
          this.lineChartSeries = series
          // Se houver mais séries que cores, repete as cores
          let coresUsadas = []
          for (let i = 0; i < series.length; i++) {
            coresUsadas.push(cores[i % cores.length])
          }
          this.lineChartOptions.colors = coresUsadas
          // Ajustar categorias do eixo X para o maior conjunto de datas
          const todasDatas = Object.values(respostasPorUnidade).flat().map(r => this.formatDate(r.created))
          this.lineChartOptions.xaxis.categories = [...new Set(todasDatas)]
        }

        // Atualizar dados do heatmap
        let notasFrequencia = Array(11).fill(0) // Array para contar frequência de cada nota (0-10)
        this.respostas.forEach(resposta => {
          notasFrequencia[resposta.nota]++
        })
        this.heatmapSeries = [{
          name: 'Frequência',
          data: notasFrequencia.map((valor, index) => ({
            x: index.toString(),
            y: valor
          }))
        }]

        // Atualizar dados do radar
        const mesAtual = {
          nps: this.pontuacao,
          detratores: this.percentDetra,
          neutros: this.percenteNeutro,
          promotores: this.percentPromo,
          respostas: this.respostas.length
        }

        this.radarChartSeries = [
          {
            name: 'Mês Atual',
            data: [
              mesAtual.nps,
              mesAtual.detratores,
              mesAtual.neutros,
              mesAtual.promotores,
              mesAtual.respostas
            ]
          }
        ]

        //CALCULO PARA O GRAFICO DE EVOLUÇÂO DO NPS
        this.totalRespostadia.length = this.datasGrap.length
        for (var n=0; n<=this.datasGrap.length-1; n++) {
          if (n > 0)
            this.totalRespostadia[n] = this.totalRespostadia[n-1] + parseInt((this.values[0][n] || 0) + (this.values[1][n] || 0) + (this.values[2][n] || 0))
          else
            this.totalRespostadia[n] = parseInt((this.values[0][n] || 0) + (this.values[1][n] || 0) + (this.values[2][n] || 0))
        }
        this.calculaNPSdiario(this.totalRespostadia)
        //FIM DO CALCULO PARA O GRAFICO DE EVOLUÇÂO DO NPS

        if (this.promotores != 0 || this.detratores != 0 || this.neutros != 0) {
          this.percentDetra = this.detratores * 100 / this.respostas.length
          this.percenteNeutro = this.neutros * 100 / this.respostas.length
          this.percentPromo = this.promotores * 100 / this.respostas.length
          this.pontuacao = parseInt(this.percentPromo.toFixed(0)) - parseInt(this.percentDetra.toFixed(0))
        }
        if (this.pontuacao >= -100 && this.pontuacao <= -1) {
          this.corPontNps = '#D32F2F'
          this.msgPontuacao = 'Pontuação (-100 à -1) Zona Crítica.'
          this.descPontuacao = 'É algo urgente, caso ações não sejam tomadas, clientes deixarão de fazer negócio com sua marca, irão procurar a concorrência e lhe recomendarão negativamente.'
          this.corMsg = '#EF5350'
          this.iconMsg = 'sentiment_very_dissatisfied'
        }
        if (this.pontuacao >= 0 && this.pontuacao <= 49) {
          this.corPontNps = '#FF8F00'
          this.msgPontuacao = 'Pontuação (0 à 49) Zona de Aperfeiçoamento.'
          this.descPontuacao = 'Essa é a zona na qual pode ser mais fácil aumentar o NPS dado que o valor atual é baixo. Os números de promotores e detratores são bem parecidos'
          this.corMsg = '#FFA000'
          this.iconMsg = 'sentiment_satisfied'
        }
        if (this.pontuacao >= 50 && this.pontuacao <= 74) {
          this.corPontNps = '#1565C0'
          this.msgPontuacao = 'Pontuação (50 à 74) Zona de Qualidade.'
          this.descPontuacao = 'A partir dessa zona torna-se cada vez mais difícil evoluir o NPS, uma vez que os valores já são considerados alto. O número de promotores já é maior que o de detratores.'
          this.corMsg = 'info'
          this.iconMsg = 'sentiment_satisfied_alt'
        }
        if (this.pontuacao >= 75 && this.pontuacao <= 100) {
          this.corPontNps = '#388E3C'
          this.msgPontuacao = 'Pontuação (75 à 100) Zona de Excelência.'
          this.descPontuacao = 'Estar nessa zona é sinal de referência em experiência do cliente. Atingir um NPS 100 é um grande desafio, o objetivo deve ser sempre um NPS maior do que o que você tinha.'
          this.corMsg = '#43A047'
          this.iconMsg = 'sentiment_very_satisfied'
        }
        this.isLoading = false
      },

      print() {
        var opts = {
          /* stylesheets:"<link rel='stylesheet' href='../Content/styles/minify/main.min.css'>", */
          pageTitle: "Lista de Atendimentos Realizados"
        }
        PH.printElement(document.getElementById('atendimentos'),opts)
      },

      calculeDate (dias) {
        if (!dias) return null
        switch (dias) {
          case 7:
            this.corSelec = "#388E3C"
            break;
          case 15:
            this.corSelec = "#1565C0"
            break;
          case 30:
            this.corSelec = "#1565C0"
            break;
          case 60:
            this.corSelec = "#FF8F00"
            break;
          case 90:
            this.corSelec = "#D32F2F"
            break;
          default:
            break;
        }
        this.diasSelc = dias
        this.datePeriodo = new Date()
        this.datePeriodo.setDate(this.datePeriodo.getDate()-dias)
      },

      calculaNPSdiario(valores) {
        this.pontuacaoDia = []
        this.pontuacaoDia.push([])
        var totalDetraDia = 0
        var totalPromoDia = 0
        for (var p=0; p<=valores.length-1; p++) {
          totalDetraDia = totalDetraDia + parseInt(this.values[0][p] || 0)
          totalPromoDia = totalPromoDia + parseInt(this.values[2][p] || 0)
          this.detraDia = totalDetraDia * 100 / valores[p]
          this.promoDia = totalPromoDia * 100 / valores[p]
          this.pontuacaoDia[0].push(parseInt(this.promoDia.toFixed(0)) - parseInt(this.detraDia.toFixed(0)))
        }
      },

      calculaNPSTotal() {
        this.pontuacaoTotal = [[],[],[]]
        //this.pontuacaoTotal.push([0])
        var totalDetraDia = 0
        var totalPromoDia = 0
        var totalNeutroDia = 0
        for (var p=0; p<=this.datasGrap.length-1; p++) {
          totalDetraDia = parseInt(this.values[0][p] || 0)
          totalPromoDia = parseInt(this.values[2][p] || 0)
          totalNeutroDia = parseInt(this.values[1][p] || 0)
          this.pontuacaoTotal[0].push(totalDetraDia)
          this.pontuacaoTotal[1].push(totalNeutroDia)
          this.pontuacaoTotal[2].push(totalPromoDia)
        }
      },

      formatDate (date) {
        if (!date) return null
        const [month, day] = date.substr(5,5).split('-')
        return `${day}/${month}`
      },

      async carregaTodasRespostas(dataInicio, dataFim) {
        await axios.post(baseApiUrl + 'Respostas/respostasNps?access_token=' + sessionStorage.getItem('accToken'), {"empresaId": this.empresaAtivaId, "dataInicio": dataInicio, "dataFim": dataFim})
        .then(response => {
          if (response.data) {
            this.respostas = response.data
            this.perguntas = []
            this.pegaDetratores(response.data, 'TODOS')
            this.calculaNPS()
          }
        })
      },

      formatData (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      pegaDetratores(lista, tipoQuestionario) {
        let detratores = []

        for (let i = 0; i < lista.length; i++) {
          if (lista[i].nota >= 0 && lista[i].nota <= 6) {
            detratores.push({
              "nota": lista[i].nota,
              "created": lista[i].created,
              "questionarioId": lista[i].questionarioId,
              "questionario": tipoQuestionario == 'TODOS' ? lista[i].questionario : lista[i].questionario.titulo,
              "codPesquisa": lista[i].codPesquisa,
              "feedback": lista[i].feedback || '',
            })
          }
        }

        this.tabelaDetratores.conteudoDetratores = detratores
      },

      async exibeDetratores() {
        this.isLoading = true

        // Busca todos os codPesquisa únicos dos detratores
        const codPesquisas = this.tabelaDetratores.conteudoDetratores.map(item => item.codPesquisa)

        // Faz uma única requisição para todos os codPesquisa
        const response = await axios.get(
          baseApiUrl + 'ServiceNotas?access_token=' + sessionStorage.getItem('accToken') + '&filter=' +
          encodeURIComponent(JSON.stringify({ where: { codPesquisa: { inq: codPesquisas } } }))
        )

        // Cria um mapa para facilitar a busca
        const notasMap = {}
        response.data.forEach(nota => {
          notasMap[nota.codPesquisa] = nota
        })

        // Atualiza os dados dos detratores
        this.tabelaDetratores.conteudoDetratores.forEach(item => {
          const nota = notasMap[item.codPesquisa]
          if (nota) {
            item.clienteNome = nota.clienteNome
            item.clienteTelefone = nota.clienteTelefone
          } else {
            item.clienteNome = ''
            item.clienteTelefone = ''
          }
        })

        await this.montaListaExportacao(this.tabelaDetratores.conteudoDetratores);
        this.dialogoExibeDetratores = true
        this.isLoading = false
      },

      async montaListaExportacao(lista) {
        this.listaDetratores = []
        const meses = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']

        function sanitize(str) {
          if (!str) return '';
          return str.normalize('NFD').replace(/[^\w\s\-/]/gi, '').replace(/\s+/g, ' ').trim();
        }

        for (let i = 0; i < lista.length; i++) {
          let mes = ''
          if (lista[i].created) {
            const dataObj = new Date(lista[i].created)
            mes = meses[dataObj.getMonth()]
          }
          let unidade = ''
          if (typeof lista[i].questionario === 'string') {
            unidade = lista[i].questionario
          } else if (lista[i].questionario && lista[i].questionario.titulo) {
            unidade = lista[i].questionario.titulo
          }
          unidade = sanitize(unidade)

          let obs = ''
          try {
            const dataInicio = lista[i].created.substring(0, 10)
            const dataFim = lista[i].created.substring(0, 10)
            const res = await axios.post(baseApiUrl + 'Respostas/porQuestionario?access_token' + sessionStorage.getItem('accToken'), {
              questionarioId: lista[i].questionarioId,
              dataInicio,
              dataFim
            })
            if (res.data && Array.isArray(res.data.respostas)) {
              const respostaDetalhe = res.data.respostas.find(r => r.codPesquisa === lista[i].codPesquisa)
              if (respostaDetalhe && Array.isArray(res.data.perguntas)) {
                const perguntaFeedback = res.data.perguntas.find(p => (p.tipo === 'FEEDBACK' || (p.text && p.text.toLowerCase().includes('coment'))))
                if (perguntaFeedback && perguntaFeedback.value) {
                  obs = respostaDetalhe[perguntaFeedback.value] || ''
                  // Remove acentuação e caracteres especiais do OBS
                  obs = sanitize(obs)
                  // Garante quebra de linha para Excel e envolve em aspas duplas
                  if (obs) {
                    obs = obs.replace(/\r?\n/g, '\r\n')
                    obs = '"' + obs.replace(/"/g, '""') + '"'
                  }
                }
              }
            }
          } catch (e) {
            obs = ''
          }

          this.listaDetratores.push({
            Nome: sanitize(lista[i].clienteNome),
            Telefone: sanitize(lista[i].clienteTelefone),
            Nota: lista[i].nota,
            Mes: mes,
            Unidade: unidade,
            Respondido: '',
            'Motivo da reclamação': '',
            OS: '',
            Qualiex: '',
            OBS: obs,
            'Tratativa realizada por': ''
          })
        }
      },

      async verDetalhes(item) {
        this.isLoading = true

        await axios.post(baseApiUrl + 'Respostas/porQuestionario?access_token=' + sessionStorage.getItem('accToken'), {"questionarioId": item.questionarioId, "dataInicio": item.created.substring(0, 10), "dataFim": item.created.substring(0, 10)})
        .then(response => {
          if (response.data) {
            for (let i = 0; i < response.data.respostas.length; i++) {
              if (response.data.respostas[i].codPesquisa == item.codPesquisa) {
                this.tabelaDetratoresDetalhes.conteudo.push(response.data.respostas[i])
                break
              }
            }

            this.tabelaDetratoresDetalhes.cabecalho = this.removerUltimoElemento(response.data.perguntas)
            this.dialogoExibeDetratores = false
            this.dialogoExibeDetalhesDetratores = true
          }
        })

        this.isLoading = false
      },

      removerUltimoElemento(lista) {
        lista.pop()
        return lista
      },

      atualizarGraficos() {
        // Implementação do filtro por período
        let dadosFiltrados = [...this.respostas]

        switch(this.periodoGrafico) {
          case 'dia':
            // Manter dados diários (já é o padrão)
            break
          case 'semana':
            // Agrupar por semana
            dadosFiltrados = this.agruparPorPeriodo(this.respostas, 'week')
            break
          case 'mes':
            // Agrupar por mês
            dadosFiltrados = this.agruparPorPeriodo(this.respostas, 'month')
            break
        }

        // Recalcular métricas com dados filtrados
        this.calculaNPSComDados(dadosFiltrados)
      },

      agruparPorPeriodo(respostas, periodo) {
        const grupos = {}

        respostas.forEach(resposta => {
          const data = moment(resposta.created)
          const chave = periodo === 'week' ?
            data.startOf('week').format('DD/MM') :
            data.format('MM/YYYY')

          if (!grupos[chave]) {
            grupos[chave] = []
          }
          grupos[chave].push(resposta)
        })

        return Object.values(grupos).flat()
      },

      calculaNPSComDados(respostas) {
        // Reutilizar a lógica do calculaNPS mas com os dados filtrados
        this.respostas = respostas
        this.calculaNPS()
      },

      atualizarRadar() {
        this.isLoading = true
        let periodoComparativo = 1 // Padrão para "Último Mês"

        switch(this.mesComparativo) {
          case 'Atual':
            periodoComparativo = 0
            break
          case 'Último Mês':
            periodoComparativo = 1
            break
          case 'Há 2 Meses':
            periodoComparativo = 2
            break
        }

        const mesAtual = moment()
        const mesComparacao = moment().subtract(periodoComparativo, 'months')

        // Datas para o mês atual
        const dataInicioMesAtual = mesAtual.startOf('month').format('YYYY-MM-DD')
        const dataFimMesAtual = mesAtual.endOf('month').format('YYYY-MM-DD')

        // Datas para o mês de comparação
        const dataInicioMesComparacao = mesComparacao.startOf('month').format('YYYY-MM-DD')
        const dataFimMesComparacao = mesComparacao.endOf('month').format('YYYY-MM-DD')

        // Função para buscar dados de um período
        const buscarDadosPeriodo = async (dataInicio, dataFim) => {
          if (this.pesquisaId.includes('Todos')) {
            return axios.post(`${baseApiUrl}Respostas/respostasNps?access_token=${sessionStorage.getItem('accToken')}`, {
              "empresaId": this.empresaAtivaId,
              "dataInicio": dataInicio,
              "dataFim": dataFim
            })
          } else {
            return axios.get(`${baseApiUrl}Respostas?filter={"where":{"and":[{"perguntaId":"' + this.pesquisaId[0] + '"},{"created":{"gte":"${dataInicio}"}},{"created":{"lte":"${dataFim}"}}]}, "include":"questionario"}&access_token=${sessionStorage.getItem('accToken')}`)
          }
        }

        // Buscar dados dos dois períodos
        Promise.all([
          buscarDadosPeriodo(dataInicioMesAtual, dataFimMesAtual),
          buscarDadosPeriodo(dataInicioMesComparacao, dataFimMesComparacao)
        ]).then(([resAtual, resComparacao]) => {
          const dadosMesAtual = this.calcularMetricasMes(resAtual.data || [])
          const dadosMesComparacao = this.calcularMetricasMes(resComparacao.data || [])

          // Atualizar série do gráfico radar
          this.radarChartSeries = [
            {
              name: 'Mês Atual',
              data: [
                dadosMesAtual.nps,
                dadosMesAtual.detratores,
                dadosMesAtual.neutros,
                dadosMesAtual.promotores,
                dadosMesAtual.respostas
              ]
            },
            {
              name: this.mesComparativo,
              data: [
                dadosMesComparacao.nps,
                dadosMesComparacao.detratores,
                dadosMesComparacao.neutros,
                dadosMesComparacao.promotores,
                dadosMesComparacao.respostas
              ]
            }
          ]

          this.isLoading = false
        }).catch(
          //console.error('Erro ao buscar dados:', error)
          this.isLoading = false
        )
      },

      calcularMetricasMes(respostas) {
        let detratores = 0
        let neutros = 0
        let promotores = 0

        if (!Array.isArray(respostas) || respostas.length === 0) {
          return {
            nps: 0,
            detratores: 0,
            neutros: 0,
            promotores: 0,
            respostas: 0
          }
        }

        respostas.forEach(r => {
          const nota = parseInt(r.nota)
          if (nota <= 6) detratores++
          else if (nota <= 8) neutros++
          else promotores++
        })

        const total = respostas.length
        const percentDetratores = total ? (detratores * 100 / total) : 0
        const percentNeutros = total ? (neutros * 100 / total) : 0
        const percentPromotores = total ? (promotores * 100 / total) : 0

        return {
          nps: percentPromotores - percentDetratores,
          detratores: percentDetratores,
          neutros: percentNeutros,
          promotores: percentPromotores,
          respostas: total
        }
      },

      async carregaRespostasMultiplas(dataInicio, dataFim) {
        // Se for 'Todos', usa o endpoint antigo
        if (this.pesquisaId.includes('Todos')) {
          await this.carregaTodasRespostas(dataInicio, dataFim)
          return
        }
        // Busca todas as perguntas NPS de uma vez
        const perguntasResp = await axios.get(
          baseApiUrl + 'Perguntas?filter=' +
          encodeURIComponent(JSON.stringify({
            where: {
              questionarioId: { inq: this.pesquisaId },
              tipo: 'NPS'
            }
          })) +
          '&access_token=' + sessionStorage.getItem('accToken')
        )
        const perguntas = perguntasResp.data
        if (!perguntas.length) {
          this.respostas = []
          this.pegaDetratores([], null)
          this.calculaNPS()
          return
        }
        // Busca todas as respostas dessas perguntas de uma vez
        const perguntaIds = perguntas.map(p => p.id)
        const respostasResp = await axios.get(
          baseApiUrl + 'Respostas?filter=' +
          encodeURIComponent(JSON.stringify({
            where: {
              perguntaId: { inq: perguntaIds },
              created: { gte: dataInicio + 'T00:00:00.000Z', lte: dataFim + 'T23:59:59.999Z' }
            },
            include: 'questionario'
          })) +
          '&access_token=' + sessionStorage.getItem('accToken')
        )
        this.respostas = respostasResp.data
        this.pegaDetratores(respostasResp.data, null)
        this.calculaNPS()
      },

      onPesquisaChange(val) {
        // ... lógica existente ...
        if (val.includes('Todos')) {
          if (val.length === 1) {
            this.pesquisaId = this.pesquisas.filter(p => p.id !== 'Todos').map(p => p.id)
          } else if (val.length < this.pesquisas.length) {
            this.pesquisaId = this.pesquisas.filter(p => p.id !== 'Todos').map(p => p.id)
          } else {
            this.pesquisaId = []
          }
        } else {
          this.pesquisaId = val.filter(id => id !== 'Todos')
        }
        if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          this.carregaPerguntas();
        }, 1000); // 1 segundo de debounce
      },

      onTodosClick() {
        if (this.todosSelecionados) {
          this.pesquisaId = []
        } else {
          this.pesquisaId = this.pesquisas.filter(p => p.id !== 'Todos').map(p => p.id)
        }
        // Força o menu a fechar e reabrir para atualizar o visual
        this.$refs.selectPesquisas.blur()
        this.$nextTick(() => {
          this.$refs.selectPesquisas.focus()
        })
      }
    }
  }
</script>

<style scoped>
.home-container {
  padding: 20px 24px;
}

/* --- Tokens do design system (mesmos das demais telas) --- */
.av-filtro-card {
  padding: 16px;
  margin-bottom: 16px;
}

.av-section-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: .4px;
  text-transform: uppercase;
  color: var(--av-text-soft);
  margin-bottom: 8px;
}

.av-field-label {
  display: block;
  font-size: 12.5px;
  font-weight: 500;
  color: #2c3a3a;
  margin-bottom: 6px;
}

.av-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  flex-wrap: wrap;
}

.av-busca { max-width: 280px; }

.av-dialog-title {
  font-size: 17px;
  font-weight: 600;
  color: var(--av-text);
  padding-bottom: 2px;
}

.av-export-label {
  display: inline-flex;
  align-items: center;
}

::v-deep .av-export-label,
::v-deep .v-btn a {
  color: inherit;
  text-decoration: none;
}

/* Respiro confortável entre os filtros */
::v-deep .av-filtro-card .row > [class*="col"] {
  padding-top: 6px;
  padding-bottom: 6px;
}

/* Cartões de métrica: superfície branca + faixa de acento na cor semântica */
.av-metric {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 18px;
  border-left: 4px solid var(--accent);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.av-metric--clickable {
  cursor: pointer;
}

.av-metric--clickable:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(31, 42, 42, .12);
}

.av-metric-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
}

.av-metric-info {
  display: flex;
  flex-direction: column;
}

.av-metric-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--av-text);
}

.av-metric-sub {
  font-size: 12px;
  color: var(--av-text-soft);
  margin-top: 2px;
}

.av-metric-pct {
  font-size: 12px;
  font-weight: 600;
  color: var(--accent);
}

.av-metric-value {
  margin-top: auto;
  padding-top: 14px;
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  color: var(--accent);
}

/* Cartões de gráfico no padrão av-card (planos, borda sutil) */
.chart-card {
  border-radius: var(--av-radius);
  border: 1px solid var(--av-border);
  box-shadow: var(--av-shadow);
  height: 500px;
  min-height: 450px;
  display: flex;
  flex-direction: column;
}

::v-deep .chart-card .v-card__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--av-text);
  border-bottom: 1px solid var(--av-border);
}

.month-select {
  max-width: 150px;
}

/* Tabelas no padrão av-table */
::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
  color: var(--av-text-soft) !important;
  background: #f7f9f9;
  font-size: 12.5px;
  font-weight: 600;
  white-space: nowrap;
  border-bottom: 1px solid var(--av-border) !important;
}

::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
  height: 46px;
}

::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
  border-bottom: 1px solid #eef1f1 !important;
  font-size: 13.5px;
}

::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
  background: #f5f8f8;
}

::v-deep .av-table.v-data-table {
  background: transparent;
}

.select-unidade-fixo .v-select__selections,
.select-unidade-fixo .v-select__selection--comma,
.select-unidade-fixo .v-select__selection,
.select-unidade-fixo .v-input__slot {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100%;
  line-height: 40px;
  height: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
}
.select-unidade-fixo .v-select__selections > * {
  max-width: 100%;
  min-width: 0;
}

.apexcharts-legend {
  flex-wrap: wrap !important;
  max-width: 100% !important;
}
</style>
